// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoPlayerPage-cls1_6ys","cls2":"VideoPlayerPage-cls2_fzA VideoPlayerPage-cls1_6ys"};